/* Application: Educational Resources
 ========================================================================== */

//set name of localStorage key
window.aaStorageName = 'aapc';

//create localStorage getter/setter functions
window.aaStorage = {
    //get product object that's stored in localeStorage,
    //if there isn't anything store return empty object
    fetch: () => {
        return JSON.parse(localStorage.getItem(window.aaStorageName)) || {};
    },

    //add product to localStorage basket
    save: products => {
        localStorage.setItem(window.aaStorageName, JSON.stringify(products));
    },

    //remove all products from localStorage
    kill: () => {
        localStorage.removeItem(window.aaStorageName);

        //remove all items from application so the cart updates immediately
        window.aaResourceApp.resources = {};

        //trigger cart update due to removing everything from localStorage
        window.aaResourceApp.updatedCart = true;

        const resource_sidebar = $('.resource_sidebar');

        if( resource_sidebar.length > 0 ) {
            resource_sidebar.css('top', '0');
        }

    },

};

app.resource_cart = function () {
    'use strict';

    //declare storage in this scope
    const Storage = window.aaStorage;

    Vue.component('resource-message', {
        props: ['currentMessage', 'displayMessage'],

        template: '<div class="alert alert-success">{{ currentMessage }}</div>',
    });

    window.aaResourceApp = new Vue({
        el: '#resourcesApp',

        data: {
            updatedCart: false,
            aapc: Storage.fetch(),
            showBasketTotalThreshold: 0,
            resources: {},
            messages: {
                'updated' : 'Success, Your resource cart has been updated',
                'removed' : 'Success, Resource has been removed from cart',
                'added' : 'Success, Resource has been added to your order cart'
            },
            currentMessage: '',
        },

        watch: {

            //watches the Vue updatedCart data attr,
            //when it changes this will be triggered
            'updatedCart': {
                handler: function () {

                    //stops triggering a function loop
                    if( this.updatedCart ) {

                        //calculate cart total
                        this.cartTotal = this.calcProductQtyTotal();

                        //reset the updatedCart so that next time a product is added it can be called
                        this.updatedCart = false;

                        this.requestResourceData();
                        
                    }
                }
            },

        },

        ready: function () {
            this.requestResourceData();
        },

        computed: {

            //when cartTotal is used in the instance this function will be called
            cartTotal: function () {
                //calculate cart total
                return this.calcProductQtyTotal();

            },

            //shows total in header basket when there are more items than the set threshold
            showTotal: function () {
                let show;

                //check cart total is greater than threshold
                if( this.cartTotal > this.showBasketTotalThreshold ){
                    show = true;
                } else {
                    show = false;
                }

                //return true or false
                return show;
            },

            //toggle when to display messages to the user
            displayMessage: function () {
                if ( this.currentMessage !== '' ) {
                    return true;
                } else {
                    return false;
                }
            },

            haveResources: function () {
              if( $.isEmptyObject(this.resources)  ){
                  return false;
              } else {
                  return true;
              }
            },

        },

        events: {

            'remove': function ( id ) {
                // `this` in event callbacks are automatically bound
                // to the instance that registered it
                this.removeProductFromStorage( id );
            },

            'update': function ( event, id ) {
                //grab the btn that was clicked
                const row = $( '#' + event.target.id);

                //get the input field from this product resource,
                //and get the input value
                let qtyInput = row.closest('tr').find('.resource_qty input');

                //set qty to what's set in the input field
                //if the value is empty return 1
                let newQty = parseInt( qtyInput.val() );

                this.updateProductInStorage( id, newQty );
            },

        },

        methods: {
            //add products to cart
            addToCart: function ( event, id ) {
                //grab the btn that was clicked
                const btn = $( '#' + event.target.id);

                //get the input field from this product resource,
                //and get the input value
                let qtyInput = btn.parent().find('.resource_qty input');

                //set qty to what's set in the input field
                //if the value is empty return 1
                let qty = parseInt( qtyInput.val() ) || 1;

                //reset quantity back to default of 1
                qtyInput.val(1);

                //add product to localStorage cart
                this.addProductToStorage( id, qty );
            },

            //add product to localStorage
            addProductToStorage: function ( id, qty ) {
                //restore the localStorage cart so we can update quantities and products
                let aapc = this.aapc;

                //check if the cart has any current products
                if( $.isEmptyObject(aapc) ) {
                    //if the localStorage cart is empty,
                    //add the product to the LS cart temp aapc, with the quantity
                    aapc[id] = qty;

                } else {
                    //if the LS cart already has products

                    if( aapc[id] !== null && typeof aapc[id] !== 'undefined' ) {
                        //if there is already an item with this item id, update the quantity
                        aapc[id] = aapc[id] + qty;

                    } else {
                        //if this item has not been added to the cart, create a new item for it + quantity
                        aapc[id] = qty;

                    }

                }

                //save our new products and quantities to localStorage
                Storage.save( aapc );

                //push a message to the front end to notify the user their cart has been updated
                this.currentMessage = this.messages.added;

                //tell Vue instance the cart has been updated so that we can re-calculate the cart total
                this.updatedCart = true;

            },

            //update quantity of product in localStorage
            updateProductInStorage: function ( id, newQty ) {

                if( newQty > 0 ) {

                    //get current cart from localStorage
                    let products = Storage.fetch();

                    //check if the new product quantity is different to what is currently set in localStorage
                    if( products[id] !== newQty ) {

                        //change the product quantity
                        products[id] = newQty;

                        //save the new cart object back to localStorage
                        Storage.save(products);

                        //push a message to the front end to notify the user their cart has been updated
                        this.currentMessage = this.messages.updated;

                        //tell Vue instance the cart has been updated so that we can re-calculate the cart total
                        this.updatedCart = true;

                    }

                } else {
                    //if the quantity has been updated and is less than 1, remove it from localStorage
                    this.removeProductFromStorage( id );
                }
            },

            //remove product from localStorage
            removeProductFromStorage: function ( id ) {

                //get current cart from localStorage
                let products = Storage.fetch();

                //remove product matching key from cart object
                delete products[id];

                //save the new cart object back to localStorage
                Storage.save( products );

                //update the resources object after removing from localStorage
                //this will update the cart table
                this.requestResourceData();

                //push a message to the front end to notify the user their cart has been updated
                this.currentMessage = this.messages.removed;

                //tell Vue instance the cart has been updated so that we can re-calculate the cart total
                this.updatedCart = true;
            },

            //calculate total number of products from localStorage object
            calcProductQtyTotal: function () {
                //setup a temp total variable, this will be returned
                var total = 0;

                //re-fetch and store the new localStorage cart object with our products
                this.aapc = Storage.fetch();

                //check that we have some products store in localStorage
                if( !$.isEmptyObject( this.aapc ) ) {
                    for( let key in this.aapc ) {
                        //loop through the products and add the quantites of each product up
                        //set the Vue cartTotal data attr each iteration
                        total = total + this.aapc[key];
                    }
                }

                //return total amount
                return total;
            },

            //ajax call to build an array of resource data
            //returns: resource name, price and id
            requestResourceData: function () {
                $.ajax({
                    url: ajaxObj.ajaxurl,
                    type: 'post',
                    data: {
                        action: 'aa_get_resource_data',
                        resources: Storage.fetch(),
                    },
                    success: result => {
                        //parse returned array
                        result =  JSON.parse( result );
                        this.resources = result;
                        this.injectToGF();
                    }
                });
            },

            //insert all of our product data into a gravity form resource content box
            injectToGF: function () {

                const gfBox = $('.gform_resource_area_list');
                const lineStart = ', ';
                let submissionStr = '';

                for( var r in this.resources ){
                    if( r > 0 ){
                        submissionStr += lineStart;
                    }
                    submissionStr += this.resources[r].qty + 'x ' + this.resources[r].name;
                }

                gfBox.val( submissionStr );

            },

            //remove product from cart
            removeFromCart: function (event, id) {
                this.$dispatch('remove', id);
            },

            updateQty: function ( event, id ) {
                this.$dispatch('update', event, id);
            },

        }

    });

};
